// extracted by mini-css-extract-plugin
export default {"container":"NeedComponent_container__u94La","textCell":"NeedComponent_textCell__QZvyj","rest":"NeedComponent_rest__EYTtE"};